export const Config = {
  API_URL: 'https://cd-wallet-qa.pymx6.com/admin',
  CURRENT_ENV: 'QA',
  ENCRYPTION_KEY: 'hJ1kT2YJarwabUf2Vuu-KL8vYqfYmLzGW7pVOaQubYg',
  GOOGLE_WEB_CLIENT_ID: '1044036154671-qrss8p73lunj3og1ss8j1r2a08nsjvhb.apps.googleusercontent.com',
  WEBSITE_URL: 'https://survey-qa.pymx6.com',
};

export const appleAuthOptions = {
  clientId: import.meta.env.VITE_PUBLIC_APPLE_CLIENT_ID || '',
  redirectURI: import.meta.env.VITE_PUBLIC_WEB_URL || '',
  scope: 'email name',
  state: 'state',
  usePopup: true,
};

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
};

/** points to  'https://cd-wallet-{{ENV}}.pymx6.com/admin */
export const apiUrl = import.meta.env.VITE_API_URL || Config.CURRENT_ENV;
// @ts-expect-error convenience typecast
export const currentEnv: 'QA' | 'PERF' | 'DEV' | 'PROD' = import.meta.env.VITE_CURRENT_ENV || Config.CURRENT_ENV;
export const encryptionKey = import.meta.env.VITE_ENCRYPTION_KEY || Config.ENCRYPTION_KEY;
export const webClientId = import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID || Config.GOOGLE_WEB_CLIENT_ID;
export const appVersion = import.meta.env.VITE_VERSION || '0.0.0';
export const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY || '';
export const websiteUrl = import.meta.env.VITE_PUBLIC_WEB_URL || Config.WEBSITE_URL;
export const googleTagManagerId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID || '';
export const standaloneBaseUrl = import.meta.env.VITE_STANDALONE_BASE_URL || '';
